import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import client, { formatApiError } from "@/lib/api";
import { StepUpDialog } from "@/components/wallet/StepUpDialog";

// Runs a sensitive admin action; on "reauth_required" asks the user to confirm identity, then retries.
export function useGuarded() {
  const [pending, setPending] = useState(null);
  const [methods, setMethods] = useState([]);
  useEffect(() => { client.get("/account/security").then((r) => setMethods(r.data.methods)).catch(() => {}); }, []);
  const run = async (fn) => {
    try { await fn(); }
    catch (e) {
      if (e.response?.status === 403 && e.response?.data?.detail === "reauth_required") setPending(() => fn);
      else toast.error(formatApiError(e.response?.data?.detail));
    }
  };
  const dialog = (
    <StepUpDialog open={!!pending} methods={methods} onClose={() => setPending(null)}
      onDone={() => { const fn = pending; setPending(null); run(fn); }} />
  );
  return [run, dialog];
}

export const inputCls = "rounded-xl bg-[#0d0d0d] border border-white/10 px-3 py-2 text-sm focus:border-[#ccff00]/50 focus:outline-none";
export const fmtDate = (v) => (v ? new Date(v).toLocaleString() : "-");

export function Stat({ label, value, prev, testid }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] p-4">
      <p className="text-[10px] font-mono-cl uppercase tracking-[0.14em] text-zinc-500">{label}</p>
      <p className="font-display text-2xl font-bold mt-1" data-testid={testid}>{value ?? "-"}</p>
      {prev !== undefined && <p className="text-[11px] text-zinc-500 mt-0.5">prev. period {prev}</p>}
    </div>
  );
}

export function SubNav({ items, value, onChange, prefix }) {
  return (
    <div className="flex gap-1.5 overflow-x-auto pb-2 mb-6">
      {items.map(([k, l]) => (
        <button key={k} data-testid={`${prefix}-${k}`} onClick={() => onChange(k)}
          className={`shrink-0 px-4 py-2 rounded-full text-xs font-semibold transition-colors ${value === k ? "bg-white text-black" : "border border-white/10 text-zinc-300 hover:bg-white/5"}`}>{l}</button>
      ))}
    </div>
  );
}
